import React from "react";
import "./OnboardingStep.scss";

interface OnboardingStepProps {
  className?: string;
  title: string;
  description: string;
  children?: React.ReactNode;
}

const OnboardingStep: React.FC<OnboardingStepProps> = ({
  className,
  title,
  description,
  children,
}) => {
  return (
    <div className={`onboarding-step ${className}`}>
      <h3>{title}</h3>
      <p>{description}</p>
      {children}
    </div>
  );
};

export default OnboardingStep;
